/**
 * 认证相关 API
 */
import request from './request'
import type {
  SendSmsRequest,
  SendSmsResponse,
  RegisterRequest,
  RegisterResponse,
  LoginRequest,
  LoginResponse,
  ResetPasswordStep1Request,
  ResetPasswordStep1Response,
  ResetPasswordStep2Request,
  ResetPasswordStep2Response,
  ApiResponse,
  BindPhoneRequest,
  AreaAndPhone,
  EmailPurpose,
} from './types'

/**
 * 1. 发送短信验证码
 * @param params 请求参数
 * @returns 响应数据
 */
export function sendSms(params: SendSmsRequest): Promise<ApiResponse<SendSmsResponse>> {
  return request.post<SendSmsResponse>('/member/send-sms', params)
}

/**
 * 2. 用户注册
 * @param params 注册参数（账号密码 或 手机号）
 * @returns 用户信息
 */
export function register(params: RegisterRequest): Promise<ApiResponse<RegisterResponse>> {
  return request.post<RegisterResponse>('/member/register', params)
}

/**
 * 3. 用户登录
 * @param params 登录参数（账号密码 或 手机验证码）
 * @returns 用户信息和 Session ID（自动存储在响应头）
 */
export function login(params: LoginRequest): Promise<ApiResponse<LoginResponse>> {
  return request.post<LoginResponse>('/member/login', params)
}

/**
 * 登出
 */
export function logout(): Promise<ApiResponse<LoginResponse>> {
  return request.post<LoginResponse>('/member/logout', {})
}

/**
 * 4. 重置密码 - 步骤1（验证手机号）
 * @param params 请求参数
 * @returns 包含 hash 的响应
 */
export function resetPasswordStep1(
  params: ResetPasswordStep1Request,
): Promise<ApiResponse<ResetPasswordStep1Response>> {
  return request.post<ResetPasswordStep1Response>('/member/reset-pwd', params)
}

/**
 * 5. 重置密码 - 步骤2（设置新密码）
 * @param params 请求参数（需要 hash）
 * @returns 响应数据
 */
export function resetPasswordStep2(
  params: ResetPasswordStep2Request,
): Promise<ApiResponse<ResetPasswordStep2Response>> {
  return request.post<ResetPasswordStep2Response>('/member/change-pwd', params)
}
/**
 * 绑定手机号
 */
export function bindPhoneApi(params: BindPhoneRequest): Promise<ApiResponse<any>> {
  return request.post<any>('/member/phone/bind', params)
}
/**
 * 发送邮件
 */
export function memberSendEmailApi(params: {
  email_address: string
  purpose: EmailPurpose
}): Promise<ApiResponse<any>> {
  return request.post<any>('/member/send-email', params)
}
/**
 * 手机号是否属于当前账号
 */
export function memberPhoneVerifyApi(
  params: AreaAndPhone,
): Promise<ApiResponse<{ verified: boolean }>> {
  return request.post<{ verified: boolean }>('/member/phone/verify', params)
}
